import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Block, CheckCircle, MarkEmailUnread } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'

import { getUserStatus, UserStatus, userStatusLabelKeys } from '../../features/organizations/components/helpers/organizationUserHelpers'
import { InternalUser } from '../../features/organizations/types/Organizations'

export const userStatusOrder: Record<UserStatus, number> = { [UserStatus.Active]: 0, [UserStatus.InvitePending]: 1, [UserStatus.Inactive]: 2 }

/** Active, invite pending or disabled, with the status as tooltip; shared by Organizations and Users. */
export const UserStatusIcon: FC<{ user: Pick<InternalUser, 'active' | 'lastLoginAt'> }> = ({ user }) => {
  const { t } = useTranslation()
  const status = getUserStatus(user)
  const label = t(userStatusLabelKeys[status])
  const icon =
    status === UserStatus.Active ? (
      <CheckCircle color="success" fontSize="small" />
    ) : status === UserStatus.Inactive ? (
      <Block color="error" fontSize="small" />
    ) : (
      <MarkEmailUnread color="warning" fontSize="small" />
    )
  return (
    <Tooltip title={label}>
      <Box display="inline-flex">{icon}</Box>
    </Tooltip>
  )
}
